const syntheticLead = {
  email: "avery.test@example.test",
  phone: "+44 7700 900123",
  lastname: "Test",
  firstname: "Avery",
  leadstatus: "SQL",
  practicename: "Example Dental Practice",
  practicepostcode: "WD7 9AB",
  practiceaddress: "1 Dental Way, London",
  practicetype: "Mixed practice",
  notes: "Interested in implants and would prefer an afternoon call.",
};

const headers = `Content-Type: application/json
X-FMC-Timestamp: 1767258000
X-FMC-Event-Id: 00000000-0000-7000-8000-000000000002
X-FMC-Signature: <base64url HMAC-SHA256 signature>`;

export function PayloadPreview({
  compact: _compact = false,
  daily = false,
}: {
  compact?: boolean;
  daily?: boolean;
}) {
  const preview = JSON.stringify(
    daily
      ? {
          type: "leads.daily",
          eventId: "00000000-0000-7000-8000-000000000002",
          leads: [
            syntheticLead,
            {
              ...syntheticLead,
              email: "jordan.example@example.test",
              phone: "+44 7700 900456",
              lastname: "Example",
              firstname: "Jordan",
            },
          ],
        }
      : {
          type: "lead.updated",
          eventId: "00000000-0000-7000-8000-000000000002",
          lead: syntheticLead,
        },
    null,
    2,
  );
  return (
    <div className="rounded-md bg-primary overflow-hidden">
      <div className="flex items-center justify-between gap-3 px-4 py-2.5 border-b border-white/10">
        <span className="text-micro font-mono text-white/60">
          POST · exact v1 outbound request · fictitious data
        </span>
        <span className="inline-flex items-center gap-1.5 text-micro text-white/65">
          <i className="fa-solid fa-shield-halved text-[10px]" />
          Synthetic
        </span>
      </div>
      <div className="px-4 py-3 border-b border-white/10">
        <div className="text-micro font-semibold uppercase tracking-[0.06em] text-white/45 mb-2">
          Request headers
        </div>
        <pre className="text-caption leading-relaxed text-white/75 font-mono overflow-x-auto scroll-thin whitespace-pre">
          {headers}
        </pre>
      </div>
      <div className="px-4 pt-3 text-micro font-semibold uppercase tracking-[0.06em] text-white/45">
        JSON body
      </div>
      <pre className="px-4 py-3.5 text-caption leading-relaxed text-white/85 font-mono overflow-x-auto scroll-thin whitespace-pre">
        {preview}
      </pre>
      <p className="px-4 py-2.5 border-t border-white/10 text-micro text-white/55">
        All values shown are synthetic. Live deliveries use the same structure and include the
        authorised tenant's lead data. The signature is calculated over the exact JSON bytes.
      </p>
    </div>
  );
}
